import {Typed} from "app/stimulus/typed-stimulus";
import {Controller} from "@hotwired/stimulus";
import Modal from "app/components/modal";
import {AsStimulusController} from "app/stimulus/as-stimulus-controller";

@AsStimulusController('modal')
export default class extends Typed(Controller<HTMLElement>)
{
    public connect(): void {
        Modal.getOne(this.element);
    }

    public hide(): void {
        Modal.getOne<Modal>(this.element)?.hide();
    }
}
